/* ============================================================
   Image with Story — section-image-with-story.js
   Scroll-in animation only. No deps.
   ============================================================ */
(function () {
  'use strict';

  const SELECTOR = '[data-image-story]';
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupAnimation(el) {
    const animation = el.dataset.animation;
    if (!animation || animation === 'none' || prefersReduced) {
      el.classList.add('is-in-view');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      el.classList.add('is-in-view');
      return;
    }

    const io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    io.observe(el);
    el.__isObserver = io;
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.__isInitialized) {
        el.__isInitialized = true;
        setupAnimation(el);
      }
    });
  }

  function destroy(el) {
    if (el && el.__isObserver) {
      el.__isObserver.disconnect();
      el.__isObserver = null;
      el.__isInitialized = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* ---------- Shopify Theme Editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    const el = e.target.querySelector(SELECTOR);
    if (el) destroy(el);
  });

  document.addEventListener('shopify:section:select', function (e) {
    const el = e.target.querySelector(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });

  document.addEventListener('shopify:block:select', function (e) {
    const el = e.target.closest(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });
})();
